"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Modal = require("./Modal");

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyUserInfoModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CompanyUserInfoModal, _Component);

  function CompanyUserInfoModal() {
    (0, _classCallCheck3.default)(this, CompanyUserInfoModal);
    return (0, _possibleConstructorReturn3.default)(this, (CompanyUserInfoModal.__proto__ || (0, _getPrototypeOf2.default)(CompanyUserInfoModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(CompanyUserInfoModal, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ title: "Info", noBottom: true }, this.props),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-8 col-xs-offset-2" },
            _react2.default.createElement(
              "h2",
              { className: "h4 mp-modal-title" },
              "YRITYSK\xC4YTT\xC4J\xC4N PROFIILILLA"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement("div", { className: "hairline" }),
            _react2.default.createElement(
              "ul",
              { className: "mp-modal-list" },
              _react2.default.createElement(
                "li",
                null,
                _react2.default.createElement("i", { className: "icon-mp-ok" }),
                _react2.default.createElement(
                  "p",
                  null,
                  "ILMOITUSTEN TARKKOJEN TIETOJEN LUKEMINEN"
                )
              ),
              _react2.default.createElement("div", { className: "clear" }),
              _react2.default.createElement(
                "li",
                null,
                _react2.default.createElement("i", { className: "icon-mp-ok" }),
                _react2.default.createElement(
                  "p",
                  null,
                  "ILMOITUKSET N\xC4KYV\xC4T KARTALLA OIKEISSA PAIKOISSA"
                )
              ),
              _react2.default.createElement("div", { className: "clear" }),
              _react2.default.createElement(
                "li",
                null,
                _react2.default.createElement("i", { className: "icon-mp-ok" }),
                _react2.default.createElement(
                  "p",
                  null,
                  "ILMOITUSTEN J\xC4TT\xC4MINEN"
                )
              ),
              _react2.default.createElement("div", { className: "clear" }),
              _react2.default.createElement(
                "li",
                null,
                _react2.default.createElement("i", { className: "icon-mp-ok" }),
                _react2.default.createElement(
                  "p",
                  null,
                  "OMIEN ILMOITUSTEN MUOKKAAMINEN"
                )
              ),
              _react2.default.createElement("div", { className: "clear" }),
              _react2.default.createElement(
                "li",
                null,
                _react2.default.createElement("i", { className: "icon-mp-ok" }),
                _react2.default.createElement(
                  "p",
                  null,
                  "VASTAANOTTOLIPUKKEIDEN OSTAMINEN"
                )
              ),
              _react2.default.createElement("div", { className: "clear" }),
              _react2.default.createElement(
                "li",
                null,
                _react2.default.createElement("i", { className: "icon-mp-ok" }),
                _react2.default.createElement(
                  "p",
                  null,
                  "KULJETUSSOVELLUS"
                )
              ),
              _react2.default.createElement("div", { className: "clear" })
            ),
            _react2.default.createElement(
              "p",
              { className: "profile-modal-text" },
              _react2.default.createElement(
                "b",
                null,
                "Hinnoittelu:"
              ),
              _react2.default.createElement("br", null),
              "Profiilin hinta on 225 \u20AC (282,40 \u20AC sis. alv. 25.5%) / 6 kk"
            )
          )
        )
      );
    }
  }]);
  return CompanyUserInfoModal;
}(_react.Component), _class.propTypes = {
  isShowingModal: _react.PropTypes.bool.isRequired,
  handleClose: _react.PropTypes.func.isRequired
}, _temp);
exports.default = CompanyUserInfoModal;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/modal/CompanyUserInfoModal.js
 ** module id = 308
 ** module chunks = 0
 **/